import { useState } from 'react'
import { COLORS, TYPE } from './tokens'

const OPTIONS = [
  { id: 'accepted', label: 'Approve', color: '#2D7A4A' },
  { id: 'modified', label: 'Modify', color: '#B7791F' },
  { id: 'rejected', label: 'Reject', color: '#C04A3D' }
]

export default function FindingDispositionMenu({ disposition = 'pending', onChange }) {
  const [open, setOpen] = useState(false)
  const current = OPTIONS.find(o => o.id === disposition)
  const label = current ? current.label : 'Pending review'
  const color = current ? current.color : COLORS.mutedText

  return (
    <div style={{ display: 'inline-flex', position: 'relative' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          ...TYPE.supporting,
          padding: '4px 10px',
          background: current ? `${color}12` : 'transparent',
          color,
          border: `1px solid ${current ? `${color}40` : COLORS.hairline}`,
          borderRadius: '4px',
          cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', gap: '6px'
        }}
      >
        {label}
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
          <path d="M2 3l3 3 3-3" stroke="currentColor" strokeWidth="1.4" fill="none" />
        </svg>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, marginTop: '4px',
          background: COLORS.panelBg, border: `1px solid ${COLORS.hairline}`,
          borderRadius: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
          zIndex: 10, minWidth: '120px'
        }}>
          {OPTIONS.map(o => (
            <button
              key={o.id}
              onClick={() => { onChange?.(o.id); setOpen(false) }}
              style={{
                ...TYPE.supporting,
                display: 'block', width: '100%', textAlign: 'left',
                padding: '8px 12px', background: 'transparent',
                border: 'none', cursor: 'pointer', color: o.color
              }}
            >
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
